import * as Yup from 'yup';
import { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { OutlinedInput, Stack } from '@mui/material';
import useLocales from 'src/hooks/useLocales';
// ----------------------------------------------------------------------

export default function CodeForm({
  keyPreFix = 'inputValue',
  disabled,
  value,
  focus,
  count,
  onCompleted,
  width = 42,
  height = 42,
  maxLength = 1,
}) {
  const { isRTL } = useLocales();

  const makeDefaultValues = () => {
    var tmpCodes = {};
    for (let i = 0; i < count; i++) {
      tmpCodes[`${keyPreFix}_${i + 1}`] = '';
    }
    return tmpCodes;
  };

  const VerifyCodeSchema = Yup.object().shape({
    [`${keyPreFix}_1`]: Yup.string().required('required'),
  });

  const defaultValues = makeDefaultValues();

  const { watch, control, setValue } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(VerifyCodeSchema),
    defaultValues,
  });

  useEffect(() => {
    document.addEventListener('paste', handlePasteClipboard);
    document.addEventListener('keydown', handleBackKeyPress);

    return () => {
      document.removeEventListener('paste', handlePasteClipboard);
      document.removeEventListener('keydown', handleBackKeyPress);
    };
  }, []);

  const handleSubmitEvent = (event) => {
    if (event.keyCode !== 8 || event.key !== 'Backspace') {
      const { value, name } = event.target;
      if (!name.includes(keyPreFix)) return;
      if (value.length === maxLength) submitResult();
    }
  };

  useEffect(() => {
    if (!value) return;
    replaceValue(value);
  }, [value]);

  const submitResult = () => {
    if (onCompleted) {
      var result = '';

      Object.keys(watch()).forEach((key) => (result += watch()[key]));

      onCompleted(result);
    }
  };

  const handlePasteClipboard = (event) => {
    if (event.target.name.includes(keyPreFix)) {
      let data = event?.clipboardData?.getData('Text') || '';
      replaceValue(data);
    }
  };

  const replaceValue = (data) => {
    data = data.split('');
    Object.keys(defaultValues).forEach((node, index) => {
      let value = '';
      for (let i = index * maxLength; i < maxLength + index * maxLength; i++) {
        if (data[i]) value = value += data[i];
      }

      //node.value = value;
      setValue(node, value);
    });
  };

  const handleBackKeyPress = (event) => {
    if (event.key === 'Backspace') {
      const { value, name } = event.target;
      if (!name.includes(keyPreFix)) return;
      const fieldIndex = name.replace(`${keyPreFix}_`, '');

      const fieldIntIndex = Number(fieldIndex);

      var tmp = name.split('_');
      if (tmp.length === 2 && tmp[0] === `${keyPreFix}`) {
        if (value.length <= 1) {
          const fieldIndex = `${keyPreFix}_${fieldIntIndex}`;
          setValue(fieldIndex, value);

          setTimeout(() => {
            const prevfield = document.querySelector(`input[name=${keyPreFix}_${fieldIntIndex - 1}]`);
            if (prevfield !== null) {
              prevfield.focus();
            }
          }, 0);
        }
      }
    }
  };

  const handleChangeWithNextField = (event, handleChange) => {
    const { maxLength, value, name } = event.target;
    const fieldIndex = name.replace(`${keyPreFix}_`, '');

    const fieldIntIndex = Number(fieldIndex);
    Object.keys(defaultValues).forEach((node, index) => {
      if (index > fieldIntIndex - 1) {
        setValue(node, '');
      }
    });

    if (value.length >= maxLength) {
      if (fieldIntIndex < count) {
        const nextfield = document.querySelector(`input[name=${keyPreFix}_${fieldIntIndex + 1}]`);
        if (nextfield !== null) {
          nextfield.focus();
        }
      }
    }

    handleChange(event);
  };

  return (
    <>
      <Stack direction={isRTL() ? 'row-reverse' : 'row'} spacing={1} justifyContent="space-between">
        {Object.keys(watch()).map((name, index) => (
          <Controller
            key={name}
            name={`${keyPreFix}_${index + 1}`}
            control={control}
            render={({ field }) => (
              <OutlinedInput
                {...field}
                disabled={disabled}
                autoFocus={focus && index === 0}
                id={`${keyPreFix}_${index + 1}`}
                placeholder="-"
                onKeyUp={index === count - 1 ? handleSubmitEvent : null}
                onChange={(event) =>
                  handleChangeWithNextField(event, (x) => {
                    field.onChange(x);
                    submitResult();
                  })
                }
                inputProps={{
                  maxLength: maxLength,
                  sx: {
                    p: 0,
                    textAlign: 'center',
                    width: { xs: width, sm: height },
                    height: { xs: width, sm: height },
                  },
                }}
              />
            )}
          />
        ))}
      </Stack>
    </>
  );
}
